// ============================================================
// useTeacherAssignments Hook
// ============================================================

import { useEffect } from 'react';
import useTeacherStore from '@/store/teacherStore';
import { useSchool } from './useSchool';

export function useTeacherAssignments(teacherId) {
  const { schoolId } = useSchool();
  
  const assignments = useTeacherStore((s) => s.assignments);
  const loading = useTeacherStore((s) => s.loading);
  const error = useTeacherStore((s) => s.error);
  const fetchTeacherAssignments = useTeacherStore((s) => s.fetchTeacherAssignments);

  useEffect(() => {
    if (schoolId && teacherId) {
      fetchTeacherAssignments(schoolId, teacherId);
    }
  }, [schoolId, teacherId, fetchTeacherAssignments]);

  return { assignments, loading, error, refetch: () => fetchTeacherAssignments(schoolId, teacherId) };
}
